import { useMutation } from "@apollo/client";
import { Body, Tab } from "@songtradr-one/components-frontend";
import { NotificationStatus } from "@songtradr-one/shared-common";
import { Flex } from "@songtradr-one/shared-frontend";
import {
  NotificationsPanelList_Query,
  PAGE_SIZE,
} from "../notifications-panel-list/NotificationsPanelList.Parts";
import {
  MarkAllReadButton,
  NotificationsPanelTabs_ClearUnread,
  Props,
  text,
} from "./NotificationsPanelTabs.Parts";

export const NotificationsPanelTabs = ({
  activeTab,
  setActiveTab,
  unread,
}: Props) => {
  const [clearUnreadMutation] = useMutation(NotificationsPanelTabs_ClearUnread);

  const markAllRead = () =>
    clearUnreadMutation({
      optimisticResponse: { clearUnreadNotifications: true },
      update: (cache) => {
        cache
          .readQuery({
            query: NotificationsPanelList_Query,
            variables: { limit: PAGE_SIZE, offset: 0 },
          })
          ?.notifications.user?.items.forEach((item) =>
            cache.modify({
              id: cache.identify(item),
              fields: { status: () => NotificationStatus.Read },
            }),
          );
        cache.modify({
          fields: {
            notifications: (existing, { isReference }) =>
              isReference(existing)
                ? existing
                : { ...existing, unreadCount: 0 },
          },
        });
      },
    });

  return (
    <>
      <Flex $align="center" $gap="0.5rem">
        <Tab
          label={text.tabs.all}
          $active={activeTab === "all"}
          onClick={() => setActiveTab("all")}
        />
        <Tab
          label={text.tabs.unread}
          $active={activeTab === "unread"}
          onClick={() => setActiveTab("unread")}
        />
      </Flex>
      {unread > 0 && (
        <MarkAllReadButton onClick={markAllRead}>
          <Body variant="normal">{text.markAllRead}</Body>
        </MarkAllReadButton>
      )}
    </>
  );
};
